<template>
    <div class="maskbg">
        <div class="dialog gylc" v-if="type==='index'">
            <div class="close" @click="handleClose"></div>
            <div class="flx main">
                <div class="item" v-for="(item,index) in list" :key="index" @click="show=true;content=item"></div>
            </div>
        </div>
        <div class="dialog gylc2" v-else>
            <div class="close" @click="handleClose"></div>
            <div class="flx main">
                <div class="item" v-for="(item,index) in list2" :key="index" @click="$router.push('/info?type=xl&device='+item.name)"></div>
            </div>
        </div>
        <div class="maskbg" v-if="show">
            <div class="dialog dialog_gy">
                <div class="close" @click="show=false"></div>
                <div class="main" v-if="content.info">
                    <div class="main" v-if="content.type==='image'">
                        <swiper :options="swiperOption" ref="mySwiper" class="swiper"  v-if="content.info.length>1">
                            <!-- slides -->
                            <swiper-slide v-for="(item, index) in content.info" :key="index">
                                <img :src="item">
                            </swiper-slide>
                            <!-- Optional controls -->
                            <div class="swiper-pagination" slot="pagination"></div>
                            <div class="swiper-button-prev" slot="button-prev"></div>
                            <div class="swiper-button-next" slot="button-next"></div>
                        </swiper>
                        <img :src="content.info[0]" v-else>
                    </div>
                    <div class="main" v-if="content.type==='video'">
                        <!-- <video class="video" controls :src="content.info"></video> -->
                        <video class="video" controls preload="auto">
                            <source :src="content.info" type="video/mp4">
                        </video>
                    </div>
                    <div class="main" v-if="content.type==='text'">
                        <div class="text">{{content.info}}</div>
                    </div>
                </div>
                <div v-else class="tip">规划中</div>
                
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
    components: {},
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'index'
        },
        list: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            swiperOption: {
                loop: true,
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },
                // 显示分页
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true //允许分页点击跳转
                },
                // 设置点击箭头
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev"
                }
            },
            show: false,
            
            list2: [{
                name: '原料粉碎',
            },{
                name: '螺旋输送机',
            },{
                name: '溶解罐',
            },{
                name: '净乳机',
            },{
                name: '缓冲罐',
            },{
                name: '脱脂机',
            },{
                name: '灭菌机',
            },{
                name: '凝乳罐',
            },{
                name: '压滤机',
            },{
                name: '湿法破碎机',
            },{
                name: '干燥塔',
            },{
                name: '粉碎机组',
            },{
                name: '混料机',
            },{
                name: '自动包装机',
            }],
            content: '',
        }
    },
    created() {
    },
    mounted() {
    },
    methods: {
        handleClose(){
            this.$emit('update:visible', false)
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/common';
@import '@/styles/dialog';
</style>